import React, { Component } from 'react';
import firebase from './../Firestore'
import { Link } from 'react-router-dom';

import Imagen from './Imagen'
import NavBar from './NavBar'

import config from 'react-global-configuration';

class CategoriaShow extends Component {

  constructor(props) {
    super(props);
    this.unsubscribe = null;
    this.state = {
      categoria: {},
      key: ''
    };
  }

    async componentDidMount() {
    const ref = firebase.firestore().collection('categoria').doc(this.props.match.params.id);
    this.unsubscribe = await ref.get().then((doc) => {
      if (doc.exists) {
        this.setState({
          categoria: doc.data(),
          key: doc.id,
          isLoading: false
        });
      } else {
        console.log("No such document!");
      }
    });
  }

  delete(id){
    firebase.firestore().collection('categoria').doc(id).delete().then(() => {
      console.log("Document successfully deleted!");
      this.props.history.push("/admin/categoria/lista")
    }).catch((error) => {
      console.error("Error removing document: ", error);
    });
  }

  render() {
    //console.log("render", this.state.categoria.categoriaID)
    return (
      <div className="container">
        <NavBar history={this.props.history} />
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              {this.state.categoria.nombre}
            </h3>
          </div>
          <div className="panel-body">
            <dl>
              <dt>Categoria:</dt>
              <dd>{this.state.categoria.nombre}</dd>
              <dt>Imagen:</dt>
              <dd>

                {this.state.categoria.imagen ? (
                  <img src={this.state.categoria.imagen} alt={this.state.categoria.nombre} />
                ) : (
                  <p>Esta categoria no tiene imagen</p>
                )}

                </dd>

              <dt>Orden:</dt>
              {(this.state.categoria.orden > 0 && typeof(this.state.categoria.orden) !== "undefined") ? (
                <dd>{this.state.categoria.orden}</dd>
              ) : (
                <p>No se establecio</p>
              )}

              <dt>Se puede fraccionar?:</dt>
              <dd><span className="mr-2"><small>{this.state.categoria.seFracciona ? "SI" : "NO"}</small></span></dd>





            </dl>
            <Link to={`/admin/categoria/edit/${this.state.key}`} className="btn btn-success">Editar</Link>&nbsp;
            <button onClick={this.delete.bind(this, this.state.key)} className="btn btn-danger">Delete</button>
          </div>
        </div>
      </div>
    );
  }
}

export default CategoriaShow;
